const en = {
  confirmModal: {
    content: 'This action cannot be undone',
    cancel: 'Cancel',
    confirm: 'Confirm',
  },

  navTitle: {
    event: {
      root: 'Manage event',
      list: 'List',
    },
  },

  auth: {
    logout: {
      name: 'Logout',
      success: 'Logout success',
      failed: 'Logout failed',
    },
  },

  event: {
    list: {
      delete: {
        single: {
          success: 'Delete event success',
          failed: 'Delete event failed',
          confirm: 'Do you want to delete event {{eventName}} ?',
        },
        multiple: {
          success: 'Delete {{length}} event(s) success',
          failed: 'Delete {{length}} event(s) failed',
          confirm: 'Do you want to delete {{length}} event(s) ?',
        },
      },
      filter: {
        searchTitle: 'Search event',
        startDate: 'Start date',
        endDate: 'End date',
        submit: 'Filter',
        reset: 'Reset',
      },
      table: {
        header: {
          name: 'Name',
          product: 'Product Apply',
          startDate: 'Start date',
          endDate: 'End date',
          createdDate: 'Created date',
          status: 'Status',
        },
      },
    },
    edit: 'Edit event',
    create: 'Create Event',
    title: 'Event Management',
    listEvent: 'List events',
    form: {
      name: 'Event name',
      product: 'Product apply',
      startDate: 'Start date',
      endDate: 'End date',
      status: 'Status',
      eventReward: {
        title: 'Event reward',
        type: 'Type event reward',
        value: 'Value',
      },
      type: 'Type event',
    },
  },

  common: {
    table: {
      pagination: {
        rowsPerPage: 'Rows per page:',
      },
      dense: 'Dense',
    },
    tooltip: {
      delete: {
        title: 'Delete',
      },
      edit: {
        title: 'Edit',
      },
      detail: {
        title: 'Detail',
      },
    },
  },
  successUpdatePass: 'Update Password successful',
  failUpdatePass: 'Update Password fail',
  app: `app`,
  user: `user`,
  list: `List`,
  edit: `Edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `Profile`,
  account: `Account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level_1: `menu level 1`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  search: `Search`,
  reset: `reset`,
  export: `export`,
  history_winning: `history winning`,
  showSuccessRegister: 'Sign Up Success',
  showFailRegister: 'Registration Failed',
  reset_password: 'Forgot your password?',
  send_email:
    'Please enter the email address associated with your account and We will email you a link to reset your password.',
  update_success: `Update success`,
  old_password: `Old Password`,
  new_password: `New Password`,
  confirm_password: `Confirm New Password`,
  Save: `Save`,
  old_password_required: `Old Password is required`,
  password_min_6: `Password must be at least 6 characters`,
  new_password_require: `New Password is required`,
  password_must_match: `Password must match`,
  change_password: `Change Password`,
  account_settings: `Account Settings`,
  allowed: `Allowed`,
  max_size_of: `max size of`,
  registration_date: `Registration Date`,
  first_name: `First Name`,
  last_name: `Last Name`,
  phone_number: `Phone Number`,
  status: `Status`,
  rank: `Rank`,
  address: `Address`,
  fname_require: `First Name is required`,
  lname_require: `Last Name is required`,
  pnumber_not_valid: `Phone Number is not valid`,
  address_require: `Address is required`,
  startDate: 'Start Date',
  endDate: 'End Date',
  wheelNamePlaceholder: 'Enter Wheel Name here..',
  wheelName: 'Wheel Name',
  giftCode: 'Gift Code',
  winningRate: 'Winning Rate',
  quantity: 'Quantity',
  cancel: 'Cancel',
  submit: 'Submit',
  addNewRow: 'Add New Row',
  dashboard: 'Dashboard',
  configWheel: 'Config wheel',

  create: 'Create',
  titleConfigWheel: 'Config Wheel Create',
  code: 'Code',
  active: 'Active',
  inactive: 'In Active',
  createdDay: 'Created Day',
  useTime: 'Use Time',
  editCodeHeading: 'Code Release Edit',
  successEdit: 'Successfully Changed Information',
  errorEdit: 'Change Information Failed',
  saveChange: 'Save Changes',
  confirmChange: 'Are you sure want to save changes?',
  yupStatus: 'Status is required',
  yupUseTimeType: 'Use Time must be a number',
  yupUseTimeRequired: 'Use Time is required',
  yupUseTimeNumer: 'Use Time Can Less Than 0',
  titleEdit: 'Code: Edit',
  delete: 'Delete',
  view: 'View',
  inputText: 'Input Text',
  searchText: 'Search Text',
  searchType: 'Search Type',
  filter: 'Filter',
  clear: 'Clear',
  titleCodeRelease: 'Code Release List',
  titleCodeCreate: 'Code Release Create',
  eventName: 'Event Name',
  amount: 'Amount',
  expiresAt: 'Expires At',
  ok: 'OK',
  newCode: 'New Code',
  codeUseTimePlacehoder: 'Please enter the number of times to use the codes',
  codeAmountPlacehoder: 'Please enter the total number of codes',
  yupEventName: 'Please do not leave the event name blank',
  labelEventName: 'Event Name',
  getEventNameFail: 'Get Event Name Fail',
  logout_success: `Logout successfully`,
  deleteCodeSuccess: 'Successfully deleted code',
  deleteCodeFail: 'Delete failed code',
  confirmDelete: 'Do you want to delete?',
  home: `Home`,
  settings: `Settings`,
  logout: `Logout`,
  name: `Name`,
  update_fail: `Update fail. Please try again`,
  giftList: 'List Gift',
  gift: 'Gift',
  confirmDeleteMulGift: 'Do you want to delete {{length}} gift(s) ?',
  confirmDeleteSigGift: 'Do you want to delete gift {{giftName}} ?',
  deleteGiftSuccess: 'Delete gift success',
  deleteGiftFailed: 'Delete gift failed',
  createGift: 'Create Gift',
  createGiftSuccess: 'Create gift successfully',
  createGiftFailed: 'Create gift failed',
  giftName: 'Gift Name',
  name_required: 'Name is required',
  price_required: 'Price is required',
  price_more_than_0: 'Price is more than 0',
  thumbnail_required: 'Thumnail is required',
  createNewWheelSuccess: 'Create new wheel successfully',
  createNewWheelFailed: 'Create new wheel failed',
  errorMessageRequiredForWheelName: 'Wheel name is required',
  errorMsgForEndDateRequired: 'End date is required',
  errorMsgForStartDate: 'Start date is required',
  startWheel: 'Start',
  resetWheel: 'Reset',
  uploadBgImageWheel: 'Upload image',
  previewWheel: 'Preview Wheel',
  titleEditEvent: 'Event Edit',
  eventList: 'Event list',

  yupCreateCode: {
    eventId: 'Please select an Event Name. Event Name cannot be left blank!',
    amountType: 'Amount must be a number!',
    amountRequire: 'Please enter a number. Amount cannot be left blank!',
    amountMoreThan: 'The number must be greater than 0',
    useTimeType: 'Use Time must be a number!',
    useTimeRequire: 'Please enter a number. Use Time cannot be left blank!',
    useTimeMoreThan: 'The number must be greater than 0',
    exepiresAtRequire: 'Please enter a date. Expires At cannot be left blank!',
    exepiresAtType: 'The data type must be a date, with the format dd-mm-yy hh:mm (a|p)m',
  },
  yupPostProductAttribute: {
    type: 'This field is required',
    lang: 'This field is required',
    name: 'This field is required',
    slug: 'This field is required',
    description: 'This field is required',
  },
  variant: {
    new: {
      numberAtt: '*Attribute ',
      labelAddAtt: 'Add attribute',
      titleAtt: 'Add attribute for variant',
      successBar: 'Add new variant success',
      failBar: 'Add new variant fail',
      labelName: 'Name',
      labelSku: 'Sku',
      labelQuantity: 'Quantity',
      labelAttribute: 'Product Attribute',
      labelTerm: 'Product Attribute Term',
      labelPrice: 'Price',
      labelSale: 'Sale Price',
      labelPoint: 'Point',
      labelSalePoint: 'Sale Point',
      labelImg: 'Allowed',
      labelExternal: 'Product External',
      labelExNote:
        '* If E-Voucher, please enter this line. If not, please leave it blank',
      labelWidth: 'Width',
      labelHeight: 'Height',
      labelLength: 'Length',
      labelWeight: 'Weight',
    },
    edit: {
      showSuccess: 'Edit variant successfully',
      showError: 'Edit variant fail',
      typeEx: 'External Type',
    },
  },
  attribute: {
    new: {
      titleNew: 'Add new attribute',
      titleList: 'List attribute',
      titleAttribute: 'Product attribute',
      btnCreate: 'Add new attribute',
      Name: 'Attribute name',
      labelDescription: 'Description',
      pageTitle: 'Add-new-attribute',
      addSuccess: 'Add new attribute successful',
      addFail: 'Add new attribute fail',
      labelType: 'Attribute type',
      labelSlug: 'Slug',
      labelLang: 'Language',
      labelName: 'Attribute name',
      labelBtnCreate: 'Tạo mới',
      labelBtnCancel: 'Cancel',
      schemaName: 'Please do not leave attribute name blank',
      schemaSlug: 'Please do not leave slug blank',
      schemaDescription: 'Please add description for your product',
      schemaType: 'Please chose a type for attribute',
      schemaLang: 'Please chose a language for attribute',
    },
    edit: {
      editSuccess: 'Edit attribute successful',
      editFail: 'Edit attribute fail',
      labelType: 'Attribute type',
      labelSlug: 'Slug',
      labelLang: 'Language',
      labelName: 'Attribute name',
      labelDescription: 'Description',
      labelBtnSave: 'Save change',
      labelBtnCancel: 'Cancel',
      titleEdit: 'Edit attribute',
      edit: 'Edit',
      schemaName: 'Please do not leave attribute name blank',
      schemaSlug: 'Please do not leave slug blank',
      schemaDescription: 'Please add description for your product',
    },
    list: {
      pageTitle: 'List-attribute',
      titleNew: 'Add new attribute',
      titleList: 'List attribute',
      titleAttribute: 'Product attribute',
      btnCreate: 'Add new attribute',
      Name: 'Attribute name',
      labelDescription: 'Description',
      yes: 'Yes',
      no: 'No',
      deleteSuccess: 'Delete attribute successful',
      deleteFail: 'Delete attribute fail',
    },
  },
  term: {
    navTitle: 'Attribute Term',
    list: {
      navListTitle: 'List Attribute Term',
      pageTitle: 'List-attribute-term',
      list: 'List',
      deleteSuccess: 'Delete attribute term successful',
      deleteFail: 'Delete attribute term fail',
      deleteTitle: 'Delete Attribute Term',
      deleteContent: 'Are you sure you want to delete these attribute term?',
    },
    new: {
      navNewTitle: 'Add new attribute term',
      labelAttribute: 'Product Attribute',
      labelLang: 'Language',
      labelTerm: 'Term',
      labelBtnRemove: 'Attribute value type of another language',
      labelBtnAdd: 'Add attribute value of another language',
      title: 'Add new attribute term',
      termTitle: 'Attribute term',
      newTitle: 'Add',
      newSuccess: 'Add new attribute term successful',
      newFail: 'Add new attribute term fail',
      addBtn: 'Add new',
    },
    edit: {
      labelAttribute: 'Product Attribute',
      labelLang: 'Language',
      labelTerm: 'Term',
      labelBtnRemove: 'Attribute value type of another language',
      labelBtnAdd: 'Add attribute value of another language',
      title: 'Add new attribute term',
      termTitle: 'Attribute term',
      newTitle: 'Add',
      newSuccess: 'Edit new attribute term successful',
      newFail: 'Edit new attribute term fail',
    },
  },
  ListProduct: {
    newProduct: 'New Product',
    view: 'View',
    title: 'Product List',
    type: 'Search Type',
    taxStatus: 'Tax Status',
    productType: 'Product Type',
    deleteSuccess: 'Delete Product Success',
    deleteFail: 'Delete Product Fail',
    titleProductNavbar: 'Product',
  },
  productMerchant: {
    new: {
      contentOnly1: 'With the product type you are choosing is:',
      contentOnly2: ' then you can only choose 1 variant',
      contentOnly3:
        'If you need to choose more variations please select the product type again: Configurable',
      labelDefault:
        '* Please select the default variant, if not select the first variant will be set as default variant',
      labelCancel: 'Still exiting',
      labelReturn: 'Return',
      contentReset: 'If you exit now you will lose all options',
      contentReset2: "press 'Add' if you want to save your selections",
      labelNotice: 'Notice!',
      default: 'Default',
      salePoint: 'Sale Point',
      point: 'Point',
      attribute: 'Attribute',
      attributeTerm: 'Attribute Term',
      labelSku: 'Sku',
      labelSimple: 'Simple',
      labelConfig: 'Configurable',
      labelVirtual: 'Voucher',
      title: 'Create a new product',
      new: 'New',
      create: 'Create Product',
      schemaName: 'Please do not leave the product name blank',
      schemaDescription: 'Please add a description for your product',
      schemaShortDescription: 'Please add a short description for your product',
      schemaCategoryMin: 'Please select at least 1 category',
      schemaCategory: 'Please do not leave the category blank',
      schemaTagMin: 'Please select at least 1 tag',
      schemaTag: 'Please do not leave the tag blank',
      schemaSlug: 'Please do not leave the slug blank',
      labelName: 'Product Name',
      labelStatus: 'Status of Product',
      labelFeatured: 'Feature Product',
      labelPrice: 'Price',
      labelTaxStatus: 'Price includes taxes',
      labelShortDescription: 'Short Description',
      labelType: 'Type of Product',
      labelLang: 'Language',
      slug: 'Slug',
      addSuccess: 'Add New Product Success',
      addFail: 'Add New Product Fail',
      category: 'Categories',
      tag: 'Tags',
      active: 'Active',
      description: 'Detailed description of your product here...',
      imageLabel: 'Drop or Select images for your product here,',
      labelOnSale: 'On Sale',
      thumbnail: 'Thumbnail is required',
      price: 'Price',
      sale: 'Sale',
      quantity: 'Qty.',
      sku: 'Sku',
      salePrice: 'Sale Price',
      add: 'Add',
      titleProductNavbar: 'Product',
      descriptionPlacehoder: 'Viết về sản phẩm của bạn...',
      images: 'Ảnh sản phẩm',
      createProduct: 'Tạo mới sản phẩm',
      cancel: 'Thoát',
      productType: 'Loại sản phẩm',
      labelCategory: 'Danh mục',
      labelTag: 'Gắn thẻ',
      here: 'đây',
      fromMachine: 'từ máy tính của bạn',
      allow: 'Cho phép',
      maxSize: 'Dung lượng lớn nhất',
    },
  },
  DetailProduct: {
    title: 'Product Details',
    detail: 'Detail',
    shortDes: 'Short Description',
    sku: 'SKU',
    createdDate: 'Create Date',
    des: 'Description',
    slug: 'Slug',
    lang: 'Language',
    category: 'Category',
    tag: 'Tag',
    variant: 'Variant',
    quantity: 'Quantity',
    price: 'Price',
    salePrice: 'Sale Price',
  },
  EditProduct: {
    title: 'Product Edit',
    edit: 'edit',
    productName: 'Product Name',
    active: 'Active',
    sku: 'Product Sku',
    featured: 'Feature Product',
    price: 'Price',
    tax: 'Price includes taxes',
  },
  imageIsNotUploaded: 'Image is not uploaded',
  editWheelSuccess: 'Edit wheel successfully',
  editWheelError: 'Edit wheel error',
  isNotValidDate: 'Date is invalid',
  getQRCode: 'Get QR Code',
  downloadQRCode: 'Download QR Code',
  expireAt: 'Expire at',
  infoSendSuccessfully: 'Your information is sent successfully !',
  pleaseWaitForAdminApproveAccount:
    'Please waiting for our admin team  approve your account',
  emailConfirmation: 'Email Confirmation',
  sendEmailTo: 'We have sent email to',
  confirmValidEmail:
    'to confirm the validity of your email address. After receiving the email follow the link provided to complete the registration process.',
  deleteProductAttribute: 'Delete',
  editProductAttribute: 'Edit',
  manage_product_attribute: 'Manage product attribute',
  list_product_attribute: 'List product attribute',
  create_product_attribute: 'Create product attribute',
  Lang: 'Lang',
  Type: 'Type',
  Name: 'Name',
  Slug: 'Slug',
  Description: 'Description',
  giftIsNotAvailable: 'No gift available',

  homeConfig: 'Home configuration',
  requestManagement: {
    root: 'Quản lý yêu cầu',
    list: 'Danh sách yêu cầu',
    createSpoon: 'Create Spoon Code',
    createSBPS: 'Create SBPS Code',
    notiCreateSuccess: 'Create Successfully !',
    notiCreateError: 'Create Fail !',
    createField: {
      productGroup: 'Product Group',
      quantity: 'Quantity',
      weight: 'Weight',
      useDate: 'Manufacture Time',
      status: 'Status',
      placeholderQuantity: 'Input quantity form 1 to 15000',
      spoonType: 'Spoon Type',
    },
    button: {
      cancel: 'Cancel',
      create: 'Add',
    },
    listQR: 'List QR Code',
    acceptFile: 'Accept File',
    denyFile: 'Reject File',
  },
  configEvent: {
    title: 'Config Event',
    list: 'List Config Events',
    edit: {
      success: 'Edit Config Event Successfull !',
      fail: 'Edit Config Event Fail !',
    },
    tableHeader: {
      code: 'Code',
      desc: 'Description',
      status: 'Status',
      startDate: 'Start Date',
      endDate: 'End Date',
      edit: 'Edit',
    },
    button: {
      cancel: 'Cancel',
      edit: 'Edit',
    },
    modal: {
      title: 'Change Infor Config Event',
      desc: 'Description',
      status: 'Status',
    },
  },
  featureConfig: {
    title: 'Features Management',
    list: 'Features List',
    editSuccess: 'Edit feature successful !',
    editError: 'Edit feature fail !',
    tableHeader: {
      code: 'Code',
      name: 'Name',
      status: 'Status',
      edit: 'Edit',
    },
    button: {
      cancel: 'Cancel',
      edit: 'Edit',
    },
    modal: {
      title: 'Change information feature',
      description: 'Input fields to change',
      name: 'Feature name',
      status: 'Status',
    },
  },
  // manageAgent
  manageAgent: {
    navTitle: 'Manage Admin',
    list: {
      title: 'List Admin',
      labelSearch: 'Search Text',
      labelStatus: 'Status',
      labelRank: 'Rank',
      successBar: 'Delete Admin successful',
      failBar: 'Delete Admin fail, try again later',
      modalTitle: 'Delete Admin',
      modalContent: 'Are you sure to delete this Admin',
    },
    new: {
      title: 'New Admin',
      labelEmail: 'Email',
      labelPassword: 'Password',
      labelConfirmPassword: 'Confirm Password',
      labelGrPolicy: 'Policy',
      emailSchema: 'Please do not leave Email blank',
      newPasswordMinSchema: 'Password must be at least 6 characters',
      newPasswordSchema: 'Please do not leave Password blank',
      confirmPasswordSchema: 'Password does not match, please try again',
      confirmPasswordRequired: 'You need to confirm your password again',
      groupPolicyIdsSchema: 'Please do not leave permission blank',
    },
    edit: {
      tittle: 'Edit Admin',
      successBar: 'Edit Admin successful',
      failBar: 'Edit Admin fail',
      id: 'Id',
      rank: 'Rank',
      policy: 'Policy',
      name: 'Name',
      email: 'Email',
      address: 'Address',
      phone: 'Phone Number',
      status: 'Status',
    },
  },
  group_policy: {
    root: 'Group policy',
    label: {
      name: 'Name',
      description: 'Description',
      status: 'Status',
      type: 'Type',
    },
    list: {
      root: 'Group policy list',
      add: 'Add group policy',
      delete: {
        content: 'Are you sure to delete {{groupName}}?',
        multiple_content: 'Are you sure to delete {{length}} groups?',
        root: 'delete',
        success: 'Delete group successfully',
        fail: 'Delete group failed',
        multiple_success: 'Delete {{length}} groups successfully',
        multiple_fail: 'Delete failed {{length}} groups',
      },
      schema: {
        required: 'This field is required',
        min: 'Group policy must be at least 1',
      },
      create: {
        root: 'Create Group Policy',
        name: 'Name',
        description: 'Description',
        policies: 'Policies',
        success: 'Create group policy successfully',
        fail: 'Create group policy failed',
      },
      edit: {
        root: 'Edit Group Policy',
        success: 'Edit group policy successfully',
        fail: 'Edit group policy failed',
        status: 'Status',
      },
    },
  },
  userManage: {
    title: 'User Management',
    list: 'List User',
    rank: 'Rank',
    detail: 'User Detail',
    name: 'Name',
    address: 'Address',
    email: 'Email',
    birth: 'Birthday',
    lastVisited: 'Last day visited',
    createdAt: 'Created day',
    gender: 'Gender',
    totalPoints: 'Total coin',
    lastScan: 'Last day add point',
    phoneNumber: 'Phone Number',
    editTitle: 'Edit User',
    save: 'Save',
    status: 'Status',
    blockAccount: 'Block account',
    block: 'Block add point',
    goBack: 'Go back',
    viewHistoryAddPoint: 'Addpoint history',
    viewHistoryGiftExchange: 'Gift exchange history',
    edit: 'Edit',
  },
  tag: {
    new: {
      title: 'Add New Tag',
      name: 'Name',
      slug: 'Slug',
      desc: 'Description',
      successBar: 'Add new Tag successful',
      errorBar: 'Add new Tag fail',
    },
    list: {
      title: 'List Tag',
      create: 'Create new Tag',
      successBar: 'Delete Tag successfully',
      errorBar: 'Delete Tag fail',
      confirmDelete: 'Confirm Delete',
    },
    edit: {
      title: 'Edit Tag',
      successBar: 'Edit Tag successfully',
      errorBar: 'Edit Tag fail',
    },
  },
  homeConfiguration: 'Home Configuration',
  previewHomePageTitle: 'Preview home page',
  category: {
    new: {
      title: 'Add new Category',
      lang: 'Language',
      name: 'Name',
      slug: 'Slug',
      desc: 'Description',
      successBar: 'Add new Category successful',
      errorBar: 'Add new Category fail',
    },
    title: 'Quản lí danh mục',
    list: 'Danh sách danh mục',
    deleteSuccess: 'Delete categories successful !',
    deleteFail: 'Delete categories fail !',
    add: 'Add',
    edit: {
      title: 'Edit category',
      success: 'Edit category successfully !',
      error: 'Edit category fail !',
    },
  },
  manage_store_title: 'Manage Store',
  manage_store: {
    listStore: 'List Store',
    createStore: 'Create new store',
    editStore: 'Edit Store',
    detailStore: 'Detail Store',
    code_store: 'Code',
    name_store: 'Name',
    address_store: 'Address',
    phone_store: 'Phone',
    referral_code: 'Referral Code',
    status: 'Status',
    import: {
      title: 'Import',
      sucess: 'Request import file success, waiting for minutes',
      false: 'Request import file fail',
    },
    export: {
      title: 'Export',
      sucess: 'Request export file success, waiting for minutes',
      false: 'Request export file fail',
    },
    createExternalReferrerSuccess: 'Create External Referrer Successfully',
    createExternalReferrerFailed: 'Create External Referrer Failed!',
    editExternalReferrerSuccess: 'Edit External Referrer Successfully',
    editExternalReferrerFailed: 'Edit External Referrer Failed!',
    create: {
      code_required: 'Code is required',
      code_max: 'Code is max 20',
      name_required: 'Name is required',
      address_required: 'Address is required',
      phone_required: 'Phone is required',
      phone_max: 'Phone is max 10',
      referral_code_required: 'Referral code is required',
      referral_code_invalidType: 'Invalid Type',
      referral_code_max: 'Referral code is max 9',
    },
  },
  request_export: 'Request Export',
  groupUser: {
    title: 'Group user management',
    create: 'Create Group user',
    edit: 'Edit Group user',
    detail: 'Group user detail',
    list: 'Group user list',
    createSuccess: 'Create successfully !',
    createFail: 'Create fail !',
    editSuccess: 'Edit successfully !',
    editFail: 'Edit fail !',
    form: {
      groupName: 'Group user name',
      desc: 'Description',
      listUser: 'List UserID in group',
      status: 'Status',
      pickUser: 'Pick user',
      add: 'Add',
    },
    deleteSuccess: 'Delete group user successfully !',
    deleteFail: 'Delete fail !',
  },
  survey: {
    root: 'Survey Management',
    list: 'List Survey',
    addQuestion: 'Add a Question',
    addAnswere: 'Add an Answer',
    listQuestion: 'List Questions',
    inforQuestion: 'List Answers',
    back: 'Go back',
    create: {
      title: 'Add survey',
      noticeTwoAnswere: 'Must be at least two answers',
      sucess: 'Add survey successfully !',
      fail: 'Add survey failed !',
    },
    action: {
      delete: {
        root: 'Are you sure to delete?',
        success: 'Delete survey successfully !',
        fail: 'Delete survey failed !',
      },
      view_user: {
        root: 'Users joined',
      },
      export: {
        sucess: 'Request export successfully !',
        fail: 'Request export failed !',
        redirectImportList: 'You wanna redirect to list request export ?',
      },
    },
    view: 'Detail Survey',
    edit: {
      title: 'Edit survey',
      sucess: 'Edit survey successfully !',
      fail: 'Edit survey failed !',
    },
    userSurvey: {
      title: 'Detail user survey',
      header: 'Detail user answers',
      list: 'List user answer survey',
      name: 'Name',
      phoneNumber: 'Phone number',
      answersDetail: 'Answers form detail',
      time: 'Time submit',
      export: 'Export data',
    },
  },
  notificationManage: {
    list: {
      title: 'List Notifications',
      createButton: 'Create notification',
    },
    create: {
      success: 'Create successfully',
      fail: 'Create failed !',
    },
    root: 'Notifications Management',
    edit: {
      title: 'Edit notification',
      success: 'Edit Successfully !',
      fail: 'Edit failed !',
    },
    delete: {
      success: 'Delete successfully !',
      error: 'Delete failed !',
    },
  },
  // order-management
  order: {
    detail: {
      customerName: 'Customer name',
      headerPhysical: 'Manage Order Physical',
      headerVoucher: 'Manage Order Voucher',
      successBarGHN: 'Push Delivery fail',
      failBarGHN: 'Push Delivery success',
      commonInfo: 'Common Info',
      totalWeight: 'Total Weight',
      totalHeight: 'Total Height',
      totalLength: 'Total Length',
      totalWidth: 'Total Width',
      moreInfo: 'Please provide the following additional information',
      province: 'Province/City',
      district: 'District',
      service: 'Service',
      ok: 'Ok',
      cancel: 'Cancel',
      showProduct: 'Check goods',
      titleGHN: 'Push to GHN',
      failBar: 'Download product info fail',
      orderInfo: 'Order Information',
      deliveryInfo: 'Delivery Information',
      productInfo: 'Product Information',
      push: 'Push to GHN',
      fix: 'Fix',
      orderTitle: 'Order detail',
      listOrder: 'Order list',
      labelStatus: 'Order status',
      totalMoney: 'Total money',
      totalDiscount: 'Total discount money',
      totalShipfee: 'Total ship fee',
      moneyType: 'Money type',
      createdOrder: 'Created Order',
      payOrder: 'Pay order',
      code: 'Code',
      note: 'Note',
      infoOrder: 'Order Information',
      infoShipping: 'Information shipping',
      idUser: 'User id',
      userName: 'Name',
      userPhoneNumber: 'Phone',
      userAddress: 'Address',
      infoProduct: 'Product Information',
      userPhone: 'User phone number',
      noticeSize: "*Notice: Size > 150 can't push delivery",
      shopLabel: '*Shop - send',
      addressLabel: '*Address - to',
      refund: 'Refund coin',
      refundForm: {
        title: 'Refund coin detail',
        quantity: 'Coin quantiy',
        desc: 'Input information of order',
        content: 'Content',
        cancel: 'Cancel',
        list: 'List order refunded coin',
        name: 'Name ',
        phoneNumber: 'Phone number',
        createdDate: 'Order created date',
        refundDate: 'Refunded date',
        export_success: 'Export file successfully',
        export_failed: 'Export file failed',
        type: 'Type',
      },
      export: 'Export',
    },
    edit: {
      editTitle: 'Edit Order',
      editManageOrder: 'Manage Order',
      editVoucherList: 'Manage Order E-Voucher',
      editPhysicalList: 'Manage Order Physical',
      edit: 'Edit Order',
    },
  },
  fileList: {
    title: 'List File In/Out',
    importFileList: 'File import',
  },
  historyScan: {
    title: 'History Scan',
    list: 'History Scan List',
    listDuplicate: 'List code duplicate',
    export: {
      successExport: 'Export file successfully!',
      failedExport: 'Export file failed !',
      titleConfirmExport: 'You wanna redirect to list request export ?',
      subtitleConfirmExport: 'This action cannot be undone',
      closeConfirmExport: 'Cancel',
      agreeConfirmExport: 'Accept',
      title: 'Export file',
    },
  },
  ruleManage: {
    title: 'Rule Management',
    list: 'Rule list',
    edit: 'Edit rule',
    detail: 'Rule detail',
  },
  gameGifts: {
    title: "Game's Prize management",
    list: "List  game's prize",
    create: "Create game's prize",
    edit: "Edit game's prize",
    detail: "Detail game's prize",
    modal: {
      text: 'Are you sure you want to remove these rewards ?',
    },
    deleteSuccess: 'Delete successfully !',
    deleteFailed: 'Delete failed !',
  },
  configPlayTime: {
    root: 'Config Game Play Time',
    list: {
      title: 'List config',
      header: {
        productGroup: 'Group Product',
        weight: 'Weight',
        value: 'Value',
      },
      action: {
        delete: {
          success: 'Delete config successfully',
          failed: 'Delete config failed',
          multiple_success: 'Delete {{length}} config successfully',
          multiple_failed: 'Delete {{length}} config failed',
        },
      },
    },
    create: {
      title: 'Create config',
      schema: {
        field_required: 'This field is required',
        value_min: 'Play time must be more than or equal 0.5',
      },
      form: {
        productGroup: 'Product group',
        weight: 'Weight',
        value: 'Play time',
        create_success: 'Create config successfully',
        create_fail: 'Create config failed',
        edit_success: 'Edit config successfully',
        edit_fail: 'Edit config failed',
      },
    },
  },
  configApp: {
    title: 'Config App',
    version: 'Mobile version',
    os: 'Operating system',
    list: 'Config app list',
    modal: {
      title: 'Edit config',
    },
  },
  analystPoint: {
    title: 'Statistic Point',
    startDate: 'From date',
    endDate: 'To date',
    chart: 'Chart',
  },
  statistic: 'Statistic',
  analystSpoon: {
    title: 'Statistic Spoon',
    startDate: 'From date',
    endDate: 'To date',
    chart: {
      title: 'Chart',
      used: 'Used',
      unused: 'UnUsed',
    },
  },
  configShareApp: {
    root: 'Config share app',
    add_section: 'Add banner',
    edit: 'Edit',
    save: 'Save',
  },
};

export default en;
